<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="editPartenaire" :validation-schema="PartenaireSchema">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom du Partenaire <span class="text-danger">*</span>
              </label>
              <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" v-model="formData.nom" />
              <ErrorMessage name="nom" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                UrlImage <span class="text-danger">*</span>
              </label>
              <input ref="urlImageInput" type="file" name="urlImage" accept="image/jpeg, image/png"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="urlImage" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button type="submit"
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success">
                Modifier
              </button>
              <router-link to="/liste-partenaire" class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";
export default defineComponent({
  name: "EditPartenaire",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup() {
    const PartenaireSchema = Yup.object().shape({
      nom: Yup.string().required("Le nom est obligatoire"),
      // urlImage: Yup.string().required("L'image est obligatoire"),

    });

    const router = useRouter();
    const route = useRoute();
    const partenaireId = Number(route.params.id);


    const formData = reactive({
      nom: "",
      urlImage: "" as string | File,
    });
    const urlImageInput = ref<HTMLInputElement | null>(null);

    // const handleFileUpload = (event: Event) => {
    //   const target = event.target as HTMLInputElement;
    //   const file = target.files?.[0];
    //   if (file) {
    //     formData.urlImage = file;
    //   }
    // };


    const getPartenaire = async (id: number) => {
      try {
        const response = await ApiService.get(`/partenaires/${id}`);

        const partenaire = response.data.data;
        console.log("Partenaire chargé:", partenaire);

        formData.nom = partenaire.nom || "";
        formData.urlImage = partenaire.urlImage;

        console.log("FormData après chargement:", formData);
      } catch (err: any) {
        console.error("Erreur:", err);
        error(err.response?.data?.message || "Erreur lors du chargement");
      }
    };

    const editPartenaire = async (values: any) => {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("nom", values.nom);
        if (urlImageInput.value?.files?.[0]) formDataToSend.append("urlImage", urlImageInput.value.files[0]);
        const { data } = await ApiService.put(
          `/partenaire/${partenaireId}`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (data.code === 200) {
          success(data.message);
          router.push("/liste-partenaire");
        }
      } catch (err: any) {
        console.error("Erreur update partenaire :", err);
        error(err.response?.data?.message || "Erreur lors de la modification");
      }
    };

    onMounted(async () => {
      if (partenaireId && !isNaN(partenaireId)) {
        await getPartenaire(partenaireId);
      }
    });
    return {
      PartenaireSchema,
      editPartenaire,
      formData,
      urlImageInput
      // handleFileUpload
    };
  },
});
</script>